module.exports = __webpack_public_path__ + "img/syukyaku-kyoutu-ira003.cac5fd7a.png";